export const flowConfiguration = {
  CREATE_NEW_CHANNEL:
    'This will create a new channel for each new ticket or opportunity. Use this feature carefully!',
  REPLY_BROADCAST:
    'This will send the note as a new message in the channel, and reference the original thread card',
  REMOVE_TICKETS_FROM_CHANNEL: 'Remove tickets that no longer match these tickets from this channel'
};
